import React, { memo } from "react"

interface AuroraTextProps {
  children: React.ReactNode
  className?: string
  colors?: string[]
}

/**
 * Farbverlauf im Text. Statt background-position zu animieren (zwingt den Browser,
 * jedes Bild neu zu zeichnen) schwebt nur ein weicher Lichtschein dahinter, per transform.
 */
export const AuroraText = memo(
  ({
    children,
    className = "",
    colors = ["#FF0080", "#7928CA", "#0070F3", "#38bdf8"],
  }: AuroraTextProps) => {
    return (
      <span className={`relative isolate inline-block ${className}`}>
        <span
          className="aurora-glow pointer-events-none absolute -inset-x-4 inset-y-1 -z-10 rounded-full opacity-40 blur-2xl"
          style={{ backgroundImage: `linear-gradient(90deg, ${colors.join(", ")})` }}
          aria-hidden="true"
        />
        <span
          className="bg-clip-text text-transparent"
          style={{
            backgroundImage: `linear-gradient(120deg, ${colors.join(", ")})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {children}
        </span>
      </span>
    )
  }
)

AuroraText.displayName = "AuroraText"
